module.exports = __webpack_public_path__ + "assets/img/4cf9a18234eeab4fe4e1777339c93164.png";